import * as type from '../types'

export const setActivePage = payload => {
    return{
        type: type.SET_ACTIVE_NAV_PAGE,
        index: payload
    }
}

export const setActiveChildPage = payload => {
    return{
        type: type.SET_ACTIVE_CHILD_NAV_PAGE,
        index: payload
    }
}
